import { PlayerImpressionEntity } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { presentTitle } from '@/shared/lib/movie';

import { usePrerollAnalytics } from '../../feature-player/hooks/tracker/use-preroll-analytics';

import { usePrerollsDuration } from './use-prerolls-duration';

const prerollContent: Parameters<typeof usePrerollAnalytics>[0]['eventParamsBuilder'] = ({
    uiParams: { mainUuid },
    dependencies: { getPlayerBaseInfo },
    callbackParams: [{ vsid }],
}) => {
    const basseInfo = getPlayerBaseInfo();

    const title =
        basseInfo?.content?.__typename === 'Episode'
            ? presentTitle(basseInfo?.content.episodeTitle) ?? '-'
            : '-';

    return {
        entityType: PlayerImpressionEntity.Preroll,
        uuid: 'preroll',
        title,
        vsid,
        mainUuid,
    };
};

export const useEpisodePrerollAnalytics = (contentId: string) => {
    const prerollDuration = usePrerollsDuration(contentId);

    usePrerollAnalytics({
        prerollDuration,
        contentId,
        eventParamsBuilder: prerollContent,
    });
};
